import styled from 'styled-components';
import colors from '@honeybook/hbui/dist/styles/colors';
import is from 'styled-is';

export const PendingChangesDot = styled.div<{
    diameter: number;
    withBorder?: boolean;
}>`
    width: ${props => props.diameter}px;
    height: ${props => props.diameter}px;
    background-color: ${colors.orange50};
    border-radius: 50%;
    ${is('withBorder')`
        border: 2px solid ${colors.white};
    `}
`;

export const PendingChangesDotForFlowThumbnail = styled(
    PendingChangesDot
).attrs({ diameter: 12, withBorder: true })`
    position: absolute;
    top: -6px;
    left: -6px;
`;
